import { render, staticRenderFns } from "./ThankYouForSellingPage.vue?vue&type=template&id=571b79fe&scoped=true&"
import script from "./ThankYouForSellingPage.vue?vue&type=script&lang=js&"
export * from "./ThankYouForSellingPage.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouForSellingPage.vue?vue&type=style&index=0&id=571b79fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571b79fe",
  null
  
)

export default component.exports